export default __webpack_public_path__ + "static/media/ic_kosovo.a12d76e8.svg";